module.exports = __webpack_public_path__ + "img/hochfeiler.fb1b7c57.jpg";